import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppDispatch, useAppSelector } from "eduid-hooks";
import { useCallback, useEffect } from "react";
import { useIntl } from "react-intl";
import { clearNotifications } from "slices/Notifications";
import { dynamicMessage } from "translation";
import { EduIDButton } from "./EduIDButton";
export function Notifications() {
    const info = useAppSelector((state) => state.notifications.info);
    const error = useAppSelector((state) => state.notifications.error);
    const dispatch = useAppDispatch();
    const intl = useIntl();
    useEffect(() => {
        if (info === null || info === void 0 ? void 0 : info.message.endsWith("_success")) {
            dispatch(clearNotifications());
        }
    }, [dispatch, info]);
    const handleRMNotification = useCallback((e) => {
        e.preventDefault();
        dispatch(clearNotifications());
    }, [dispatch]);
    // show errors first, information second
    const show = error || info;
    if (!show) {
        // no messages to show
        return null;
    }
    const msg = dynamicMessage(intl, show.message);
    const color = show.level === "error" ? "danger" : "success";
    const label = getLabel(intl, show.level);
    return (_jsx("div", { className: "notifications-area", "aria-live": "polite", children: _jsxs("div", { className: `alert alert-${color} alert-dismissible fade show`, role: "alert", children: [_jsx("span", { className: "horizontal-content-margin", children: _jsx("output", { "aria-label": label, children: msg }) }), _jsx(EduIDButton, { buttonstyle: "close", id: "close-error", onClick: handleRMNotification, "aria-label": "Close notification" })] }) }));
}
function getLabel(intl, level) {
    // aria-label can't be an Element, we need to get the actual translated string here
    if (level === "error") {
        return intl.formatMessage({
            id: "notifications.error",
            defaultMessage: "Error",
            description: "Notification type",
        });
    }
    return intl.formatMessage({
        id: "notifications.information",
        defaultMessage: "Information",
        description: "Notification type",
    });
}
